/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { bulkContactResultDtoSchema } from "./bulkContactResultDtoSchema";
import { z } from "zod/v4";

export const bulkContactResultsResponseDtoSchema = z.object({
    get "results"(){
                return z.array(bulkContactResultDtoSchema).describe("One result per distinct contact ID, in request order")
              }
    })